import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SuccessDialogService } from '../../_services/success-dialog.service';
import { MatStepper } from '@angular/material';
import { Router } from '@angular/router';
import { SesssionActivityService } from 'src/app/_services/sesssion-activity.service';
import { SessionActivityDataForm } from 'src/app/_models/session-activity-data-form';
import { UserSessionDataForm } from 'src/app/_models/login/user-session-data-form';
import { NavbarService } from '../../_services/navbar.service';
import { TestResultsService } from '../../_services/test-results.service';

@Component({
  selector: 'app-learning-basics',
  templateUrl: './learning-basics.component.html',
  styleUrls: ['./learning-basics.component.css']
})

export class LearningBasicsComponent implements OnInit {
  message: string
  navItemSelected: string = '';
  learningTitle: string = '';
  userDataSession;
  userDetailsId = 0;
  stepperIndex: number;
  lastSessionActivityNumber: number;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm();
  sessionActivity;
  userTestResults;

  @ViewChild('stepper') stepper: MatStepper;

  constructor(private router: Router,
    private sesssionActivityService: SesssionActivityService,
    private successDialogService: SuccessDialogService,
    private navbarService: NavbarService,
    private testResultsService: TestResultsService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userDetailsId = this.userDataSession.userDetailsId;
    }
    this.getLastSessionAcgtivityBYUserId(this.userDetailsId, 1);
    this.getUserTestResults(this.userDetailsId, 1)
  }

  getUserTestResults(userId, testType) {
    this.testResultsService.getUserTestResults(userId, testType).subscribe(
      resp => {
        this.userTestResults = resp;
      }, error => {
        console.log(error);
      })
  }

  getLastSessionAcgtivityBYUserId(userDetailId, activityType) {
    this.sesssionActivityService.getLastSessionActiityByUserId(userDetailId, activityType).subscribe(
      resp => {
        this.sessionActivity = resp;
        if (this.sessionActivity == null) {
        } else {
          this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
          this.stepper._stepHeader.forEach(
            step => {
              if (step.index <= this.lastSessionActivityNumber) {
                setTimeout(() => {
                  this.stepper.selectedIndex = step.index;
                });
              }
            })
        }
      }, error => {
        console.log(error);
      })
  }

  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = "Invention";
        break;
      case 2:
        this.message = "Patent";
        break;
      case 3:
        this.message = "Patentable inventions";
        break;
      case 4:
        this.message = "Non-patentable inventions";
        break;
      case 5:
        this.message = "Criteria to get a patent";
        break;
      case 6:
        this.message = "Steps to obtain a patent.";
        break;
      case 7:
        this.message = "Filing patent in India";
        break;
      case 8:
        this.message = "Patent filing – Pre & Post process";
        break;
      default:
        break;
    }
  }

  isSeenFirst = false;
  isSeenSecond = false;
  isSeenThird = false;
  isSeenFour = false;
  isSeenFive = false;
  isSeenSix = false;
  isSeenSeven = false;
  isSeenEight = false;

  moveNextIndex() {
    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.activityType = 1
    const currentUser = localStorage.getItem('currentUser');
    this.sessionActivityDataForm.userDetails = JSON.parse(currentUser);
    switch (indexNumber) {
      case (2):
        this.elementRef.nativeElement.style.backgroundColor = 'red';
        if (!this.isSeenSecond) {
          this.isSeenSecond = true;
          this.sessionActivityDataForm.lastActivitySession = 2;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (3):
        if (!this.isSeenThird) {
          this.isSeenThird = true;
          this.sessionActivityDataForm.lastActivitySession = 3;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (4):
        if (!this.isSeenFour) {
          this.isSeenFour = true;
          this.sessionActivityDataForm.lastActivitySession = 4;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (5):
        if (!this.isSeenFive) {
          this.isSeenFive = true;
          this.sessionActivityDataForm.lastActivitySession = 5;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (6):
        if (!this.isSeenSix) {
          this.isSeenSix = true;
          this.sessionActivityDataForm.lastActivitySession = 6;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (7):
        if (!this.isSeenSeven) {
          this.isSeenSeven = true;
          this.sessionActivityDataForm.lastActivitySession = 7;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (8):
        if (!this.isSeenEight) {
          this.isSeenEight = true;
          this.sessionActivityDataForm.lastActivitySession = 8;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      default:
        break;
    }
  }

  moveToBasicQuizz() {
    if (this.userTestResults == null) {
      this.navbarService.saveActiveNavItem('Basics of Patents Quiz')
      this.successDialogService.successDialog(1);
    } else {
      this.navbarService.saveActiveNavItem('Patent Drawing')
      this.router.navigate(['/main/learning/learnPatentDrawing']);
    }
  }
}
